import Cookies from 'js-cookie'

export const getCookie = (name) => {
  return Cookies.get(name)
}

export const setCookie = (name, value, options) => {
  return Cookies.set(name, value, options)
}

export const removeCookie = (name) => {
  return Cookies.remove(name)
}

export const consumeCookie = (name) => {
  const value = getCookie(name)
  removeCookie(name)
  return value
}
